import { render, staticRenderFns } from "./homeNew.vue?vue&type=template&id=3316d9ec&"
import script from "./homeNew.vue?vue&type=script&lang=js&"
export * from "./homeNew.vue?vue&type=script&lang=js&"
import style0 from "./homeNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports